import styled from "styled-components";

import { alpha, rem } from "@styles/Utilities.styled";

// ! THIS IS DEPRECATED AND SHOULD BE REMOVED WHEN ALL TABLES ARE REPLACED WITH MANTINE

interface StyledTableProps {
  $hasPointerCursorOnHover?: boolean;
}

export const StyledTable = styled.table<StyledTableProps>`
  width: 100%;
  margin-top: 2rem;
  text-align: left;
  border-spacing: 0;
  border-collapse: collapse;
  /* outline: 1px solid red; */

  thead {
    tr {
      background-color: var(--clr-gray-100);
      border: 1px solid var(--clr-gray-175);
    }

    th {
      font-weight: 500;
      font-size: ${rem(15)};
      padding-block: 1.1em;
    }
  }

  tbody {
    tr {
      appearance: unset;
      cursor: ${({ $hasPointerCursorOnHover }) =>
        $hasPointerCursorOnHover ? "pointer !important" : "unset"};
      border: 1px solid ${alpha("var(--clr-black)", 0.1)};
      border-top: none;

      &:not(thead > tr) {
        font-size: ${rem(14)};
      }

      &:hover {
        background-color: var(--clr-gray-100);
      }

      &.helper-row {
        border: none;
        cursor: unset;

        &:hover {
          background-color: rgb(0, 0, 0, 0);
        }

        p {
          padding-top: 4rem;
          text-align: center;
          font-size: ${rem(15)};
        }
      }
    }
  }

  th,
  td {
    padding: 1.3em 5em 1.3em 0;
    white-space: nowrap;

    &:first-child {
      padding-left: 1em;
    }

    &:last-child {
      padding-right: 1rem;
    }
  }
`;
